export default __webpack_public_path__ + "static/media/profile.9a5a2896.svg";